import { Component, ElementRef, AfterContentInit } from '@angular/core';

let uniqueId = 0;

@Component({
  selector: 'sui-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss',
})
export class RadioButtonComponent implements AfterContentInit {
  private _id?: string;

  constructor(private _element: ElementRef) {}

  get id(): string | undefined {
    return this._id;
  }

  ngAfterContentInit(): void {
    const checkbox = this._element.nativeElement.querySelector(
      'input[type="radio"]'
    );

    if (!checkbox.id) {
      checkbox.id = `sui-radio-button-${uniqueId++}`;
    }

    this._id = checkbox.id;
  }
}
